import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[RM OP Auth0 User] Load';
export const LOAD_SUCCESS = '[RM OP Auth0 User] Load Success';
export const LOAD_FAIL = '[RM OP Auth0 User] Load Fail';
export const RESET = '[RM OP Auth0 User] Reset';

export class ResetAction implements Action {
  readonly type = RESET;
}

export class LoadPayload {
  constructor(public emailAddress: string) {}
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadPayload) {}
}

export class LoadSuccessPayload {
  constructor(public item: models.OPAuth0User) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction | ResetAction;
